// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input, Col,
  Row, 
  Table,FormGroup} from "reactstrap";

import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import ReactModal from 'react-modal';
import api from "../../../apis/api";
import Calendar from "react-calendar";
import { red } from "@material-ui/core/colors";
import "../../../style/processleave.css";
import { set } from "react-ga";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ProcessYearEnd = React.memo(
  ({
    format, 
    type, 
    index, 
    currentRow, 
    onComplete
  }) => {
    const [progress, setProgress] = useState(0);
    const totalTime = 120; // 120 seconds (2 minutes)
  
    useEffect(() => {
      if (index !== currentRow) return;
    
      let interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval); // Ensure interval clears properly
            onComplete();
            return 100;
          }
          return prev + 100 / totalTime;
        });
      }, 100);
    
      return () => clearInterval(interval);
    }, [index, currentRow, onComplete, totalTime]); // Ensure dependencies are correct
  
    return (
      <tr className="border-t">

        <td className="p-3">{type}</td>
        <td className="p-3 flex items-center">
          {progress < 100 ? (
            <>
              <div className="relative w-full bg-gray-200 rounded h-3 w-48">
                <div
                  className="h-3 bg-red-400 rounded"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <span className="ml-2 text-sm">{Math.round(progress)}%</span>
            </>
          ) : (
            <span className="text-green-600 font-bold">Completed ✅</span>
          )}
        </td>
      </tr>
    );
  }
);

export default ProcessYearEnd;
